class Notice {
    form;
    messages;
    selectors;

    constructor({form, messages}) {
        this.form = form;
        this.messages = messages;
        this.selectors = {
            btn: 'button',
            error: 'error-sending',
            errorField: 'invalid',
            errorLabel: 'error-pane error-pane-side',
        };
    }

    static execute(methodName, data) {
        const self = new Notice(data);

        return self[methodName]();
    }

    acceptFail() {
        if (Object.prototype.toString.call(this.messages) === '[object Object]') {
            for (let key in this.messages) {
                if (Object.prototype.hasOwnProperty.call(this.messages, key)) {
                    const field = this.form.querySelector(`[name="${key}"]`);

                    if (field) {
                        field.classList.add(this.selectors.errorField);
                        const selectors = `${this.selectors.errorField} ${this.selectors.errorLabel}`;

                        field.insertAdjacentHTML(
                            'afterend',
                            `<label id="${key}-error" class="${selectors}" for="${key}">
                                <div class="error-inner">${this.messages[key]}</div>
                            </label>`,
                        );
                    }
                }
            }
        }
    }

    processFail() {
        const btn = this.form.querySelector(this.selectors.btn);

        btn.insertAdjacentHTML(
            'beforebegin',
            `<div class="${this.selectors.error}"><div class="error-sending__body">Ошибка</div></div>`,
        );
    }

    clear() {
        this.removeItem(`.${this.selectors.error}`);
        this.removeItem(`label.${this.selectors.errorField}`);
    }

    removeItem(name) {
        const error = this.form.querySelectorAll(name);

        if (error) {
            error.forEach((item) => {
                item.remove();
            });
        }
    }
}

export default Notice;
